module.exports = __webpack_public_path__ + "media/svg-new/access 1-3c32455f.svg";